import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

const ShowroomSection: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const { t } = useTranslation();
  const location = useLocation(); // Force le re-render à chaque changement de page

  const images = [
    "/images/showroom/showroom1.jpeg",
    "/images/showroom/showroom2.jpeg",
  ];

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Référence pour détecter la visibilité
  const ref = useRef(null);

  // **Animations**
  const fadeUpVariants = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: { duration: 0.6, ease: "easeIn" },
    },
  };

  return (
    <motion.section
      key={location.pathname} // ⚡ Force le re-render à chaque changement de page
      ref={ref}
      className="showroom-section"
      initial="hidden"
      animate="show"
      exit="exit"
    >
      {/* Contenu principal */}
      <div className="showroom-content">
        {/* Texte */}
        <motion.div className="showroom-text" variants={fadeUpVariants}>
          <motion.h2 variants={fadeUpVariants}>{t("showroom.title")}</motion.h2>
          <motion.h3 style={{ fontWeight: "bold" }} variants={fadeUpVariants}>
            {t("showroom.subTitle")}
          </motion.h3>
          <motion.p variants={fadeUpVariants}>
            {t("showroom.description1")}
          </motion.p>
          <motion.p variants={fadeUpVariants}>
            {t("showroom.description2")}
          </motion.p>

          <motion.button className="showroom-button" variants={fadeUpVariants}>
            {t("showroom.button")}
          </motion.button>
        </motion.div>

        {/* Carrousel */}
        <motion.div className="carousel-container">
          {/* Flèche gauche */}
          <FaChevronLeft
            onClick={prevImage}
            className="carousel-arrow"
            style={{ left: "20px" }}
          />

          {/* Image animée */}
          <motion.img
            key={currentImageIndex}
            src={images[currentImageIndex]}
            alt={`Showroom ${currentImageIndex + 1}`}
            className="carousel-image"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          />

          {/* Flèche droite */}
          <FaChevronRight
            onClick={nextImage}
            className="carousel-arrow"
            style={{ right: "20px" }}
          />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default ShowroomSection;
